export function ArrowLeft({ className = '' }) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="none" aria-hidden="true">
      <rect x="1.5" y="1.5" width="97" height="97" rx="48.5" stroke="currentColor" strokeWidth="3" />
      <path
        d="M32.2227 49.9974L30.6513 48.426L29.08 49.9974L30.6513 51.5687L32.2227 49.9974ZM65.556 52.2196C66.7833 52.2196 67.7782 51.2247 67.7782 49.9974C67.7782 48.7701 66.7833 47.7752 65.556 47.7752V49.9974V52.2196ZM45.556 36.6641L43.9846 35.0927L30.6513 48.426L32.2227 49.9974L33.794 51.5687L47.1273 38.2354L45.556 36.6641ZM32.2227 49.9974L30.6513 51.5687L43.9846 64.9021L45.556 63.3307L47.1273 61.7594L33.794 48.426L32.2227 49.9974ZM32.2227 49.9974V52.2196H65.556V49.9974V47.7752H32.2227V49.9974Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ArrowRight({ className = '' }) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="none" aria-hidden="true">
      <path
        d="M83.25 49.9535L86.1933 47.0102L89.1367 49.9535L86.1933 52.8968L83.25 49.9535ZM20.8125 54.116C18.5136 54.116 16.65 52.2524 16.65 49.9535C16.65 47.6546 18.5136 45.791 20.8125 45.791V49.9535V54.116ZM58.275 24.9785L61.2183 22.0352L86.1933 47.0102L83.25 49.9535L80.3067 52.8968L55.3317 27.9218L58.275 24.9785ZM83.25 49.9535L86.1933 52.8968L61.2183 77.8718L58.275 74.9285L55.3317 71.9852L80.3067 47.0102L83.25 49.9535ZM83.25 49.9535V54.116H20.8125V49.9535V45.791H83.25V49.9535Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CameraIcon({ className = '' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M4 8.5C4 7.67 4.67 7 5.5 7h2.3l1.4-2h5.6l1.4 2h2.3c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-13C4.67 19 4 18.33 4 17.5v-9Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="13" r="3.2" stroke="currentColor" strokeWidth="1.8" />
    </svg>
  );
}

export function LayersIcon({ className = '' }) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="none" aria-hidden="true">
      <path
        d="M58.3346 29.1699V26.6699C58.3346 21.9559 58.3346 19.5989 56.8702 18.1344C55.4057 16.6699 53.0487 16.6699 48.3346 16.6699H26.668C21.9539 16.6699 19.5969 16.6699 18.1324 18.1344C16.668 19.5989 16.668 21.9559 16.668 26.6699V48.3366C16.668 53.0506 16.668 55.4077 18.1324 56.8721C19.5969 58.3366 21.9539 58.3366 26.668 58.3366H29.168"
        stroke="currentColor"
        strokeWidth="6"
      />
      <rect
        x="41.668"
        y="41.6699"
        width="41.6667"
        height="41.6667"
        rx="5"
        stroke="currentColor"
        strokeWidth="6"
      />
    </svg>
  );
}
